import barba from '@barba/core';
export class WbCyberimpact {
  constructor() {
    this.init();
  }

  init() {
    const _this = this;
    return new Promise(resolve => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener('change', '.group_newsletter input', _this.validateGroupsCyberimpact.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('submit', '.wb-footer__newsletter', _this.submitFooterCyberimpact.bind(_this));
  }

  submitFooterCyberimpact(event) {
    event.preventDefault();
    const form = document.querySelector('.wb-footer__newsletter');
    const formData = new FormData(form);
    const emailValue = formData.get('wb_email');
    const formAction = form.getAttribute('action');

    if (document.querySelector('#cyberimpact_subscribe_form') == null) {
      barba.go(formAction + '?wb_email=' + emailValue);
    }
  }

  validateGroupsCyberimpact() {
    const groupCheckboxes = document.querySelectorAll('.group_newsletter input:checked');
    const groups = Array.from(groupCheckboxes)
      .map(function(checkbox) {
        return checkbox.value;
      })
      .join();

    const ciGroupsInput = document.querySelector('input[name="fields[ci_groups]"]');
    ciGroupsInput.value = groups;
  }
}
